/**
 * A seção "Enquete do dia" na página do dia do Roteiro: as enquetes deste
 * dia (abertas primeiro) e o botão de criar. Some quando a funcionalidade
 * está desligada.
 */
import { featureEnabled } from '@nv/core';
import { useState } from 'react';

import { useDiasDaViagem } from '../../trip/dias';
import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { SectionLabel } from '../../ui/primitives';
import { useEnquetes } from './api';
import { EnqueteCard } from './EnqueteCard';
import { NovaEnquete } from './NovaEnquete';

export function EnquetesDoDia({ dayId }: { dayId: string | null }) {
  const { trip, tripId } = useTrip();
  const ligado = featureEnabled(trip.features, 'enquetes');
  const dias = useDiasDaViagem(tripId);
  const enquetes = useEnquetes(tripId, dayId, ligado);
  const [criando, setCriando] = useState(false);
  if (!ligado || !dayId) return null;
  const dia = dias.days?.find((d) => d.id === dayId);
  const lista = enquetes.data?.polls ?? [];

  return (
    <div className="enq__secao" data-testid="enquetes-do-dia">
      <SectionLabel>ENQUETE DO DIA</SectionLabel>
      {lista.map((e) => (
        <EnqueteCard key={e.id} enquete={e} />
      ))}
      {lista.length === 0 && enquetes.isSuccess && <p className="enq__vazio">Nenhuma enquete neste dia. "Onde vamos jantar?" — pergunte ao grupo.</p>}
      {dia && (
        <button type="button" className="nv-btn nv-btn--secondary nv-btn--block" data-testid="nova-enquete" onClick={() => setCriando(true)}>
          <Icon name="enquete" size={18} /> Nova enquete
        </button>
      )}
      {criando && dia && <NovaEnquete dia={dia} onFechar={() => setCriando(false)} />}
    </div>
  );
}
